import React from 'react'

import { useFormikContext } from 'formik'
import { CheckboxNew } from 'SRC/ui/FormElementsNew'

export const PriceOnRequest = () => {
	const formik = useFormikContext()

	return (
		<div className='dodatna-oprema-checkbox'>
			<CheckboxNew
				id='price-on-request'
				title='Cijena na upit'
				isChecked={formik.values.priceOnRequest}
				onChange={e => { 
					formik.setFieldValue('priceOnRequest', e.target.checked)
				}}
				text='Cijena na upit'
			/>
		</div>
	)
}
